import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserDemoComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { HowToPlayScene } from './scenes/HowToPlay';

interface PhaserHowToSceneDemoProps {
}

interface PhaserHowToSceneDemoState {
}

const DemoConfig: GameConfig = {
    title: "How To Play Scene Demo",
    version: "0.9.3",
    backgroundColor: "#d3d3d3"
};

class PhaserHowToPlaySceneDemo extends React.Component<PhaserHowToSceneDemoProps, PhaserHowToSceneDemoState> {
    private Demo: Phaser.Game;
    constructor(props: PhaserHowToSceneDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserHowToPlaySceneDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserDemoComponent scenes={HowToPlayScene} config={DemoConfig} />
        </div>);
    }
}

export default PhaserHowToPlaySceneDemo;



// WEBPACK FOOTER //
// ./src/games/demos/howToPlayScene/Main.tsx